module.exports = __webpack_public_path__ + "media/images/crowdfund-25f9de376113ba462eed13b406248e51.jpg";